import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import type { Maybe } from '@/lib/types';

import { TextType } from '../TextType';

import { visibilityControl } from '../../Card.styles';
export const Container = styled(Box)<{
  $backgroundColor: string;
  $parentType: Maybe<string>;
  $visibleInDesktop?: Maybe<boolean>;
  $visibleInMobile?: Maybe<boolean>;
}>`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  height: 100%;
  display: flex;
  flex-direction: column;
  ${({ $parentType, theme }) =>
    $parentType === 'ThreeColumnStack' &&
    css`
      ${theme.media.md.up} {
        display: block;
        height: auto;
      }
    `}
  ${({ $visibleInDesktop, $visibleInMobile }) => css`
    ${visibilityControl($visibleInDesktop, $visibleInMobile)}
  `};
`;
export const ImageWrapper = styled(Box)<{ $height: number }>`
  margin-top: 32px;
  height: ${({ $height }) => $height}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled(TextType)`
  height: auto;
`;
